module.exports = __webpack_public_path__ + "static/airport-2-378bf1e979fe945bc4bf127996841bbe.jpg";